import { render, staticRenderFns } from "./DownloadAppModal.vue?vue&type=template&id=1bafb379&scoped=true"
import script from "./DownloadAppModal.vue?vue&type=script&lang=js"
export * from "./DownloadAppModal.vue?vue&type=script&lang=js"
import style0 from "./DownloadAppModal.vue?vue&type=style&index=0&id=1bafb379&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bafb379",
  null
  
)

export default component.exports